
export class Photo {

  constructor(
    public path: string,
    public midi: string,
    public mini: string
  ) {}
}
